import * as React from "react";
type IconNextProps = React.SVGProps<SVGSVGElement>;

export const IconNext: React.FC<IconNextProps> = (props) => (
  
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M13.7063 8.70664C14.0969 8.31602 14.0969 7.68164 13.7063 7.29102L8.70625 2.29102C8.31563 1.90039 7.68125 1.90039 7.29063 2.29102C6.9 2.68164 6.9 3.31602 7.29063 3.70664L10.5875 7.00039H1C0.446875 7.00039 0 7.44727 0 8.00039C0 8.55352 0.446875 9.00039 1 9.00039H10.5844L7.29375 12.2941C6.90312 12.6848 6.90312 13.3191 7.29375 13.7098C7.68437 14.1004 8.31875 14.1004 8.70938 13.7098L13.7094 8.70977L13.7063 8.70664Z" fill="#1E3050"/>
  </svg>
  
);
export default IconNext;
